import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import { useRuvixxFlags } from "providers/RuvixxFlagsProvider";

// The dataset controls read the links and the picker list as well as setting a
// link, so all three routes must be granted.
export default function useCanSetEventDataset() {
  const { enable_leads_feature } = useRuvixxFlags();
  const isAuthorized = useAuthorized([
    ACL_RELATIONSHIPS.metaAdAccount.readSwoogoEventDatasets,
    ACL_RELATIONSHIPS.metaAdAccount.readSelectableDatasets,
    ACL_RELATIONSHIPS.metaAdAccount.setSwoogoEventDataset,
  ]);
  return Boolean(enable_leads_feature) && isAuthorized;
}
